import { lineAmount } from '@sj/shared';
import { num, rp } from '../lib/format.js';

// Tabel barang nota/SPO — port itemsTable() v1 (ops.js). Kolom Diskon & HPP muncul bila relevan.

export interface ItemRow {
  name: string;
  code?: string;
  unit: string;
  qty: number;
  qty_received?: number | null;
  price: number;
  disc?: number;
  cost?: number;
  [k: string]: unknown;
}

export function ItemsTable({
  items,
  qtyKey = 'qty',
  cost = false,
}: {
  items: ItemRow[];
  qtyKey?: 'qty' | 'qty_received';
  cost?: boolean;
}) {
  const anyDisc = items.some((i) => (i.disc ?? 0) > 0);
  let total = 0;
  const rows = items.map((i, k) => {
    const q = (i[qtyKey] as number | null | undefined) ?? i.qty;
    const amt = lineAmount(q, i.price, i.disc);
    total += amt;
    return (
      <tr key={`${i.name}-${k}`}>
        <td>
          {i.name}
          <div className="muted small">{i.code || ''}</div>
        </td>
        <td className="right">
          {`${num(q)} ${i.unit}`}
          {qtyKey === 'qty_received' && i.qty_received != null && i.qty_received !== i.qty ? (
            <div className="small warn-txt">{`dimuat ${num(i.qty)}`}</div>
          ) : null}
        </td>
        <td className="right">{rp(i.price)}</td>
        {anyDisc ? <td className="right">{i.disc ? <span className="ok-txt">{`−${rp(i.disc)}`}</span> : '–'}</td> : null}
        {cost ? <td className="right muted">{rp(i.cost)}</td> : null}
        <td className="right">{rp(amt)}</td>
      </tr>
    );
  });
  return (
    <div className="tbl-wrap">
      <table className="tbl">
        <thead>
          <tr>
            <th>Produk</th>
            <th className="right">Qty</th>
            <th className="right">Harga</th>
            {anyDisc ? <th className="right">Diskon/sat</th> : null}
            {cost ? <th className="right">HPP</th> : null}
            <th className="right">Subtotal</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
        <tfoot>
          <tr>
            <td colSpan={3 + (anyDisc ? 1 : 0) + (cost ? 1 : 0)}>Total</td>
            <td className="right">{rp(total)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
